<template>
  <div
    :class="['radio-box', display === 'icon-text' && `pos-${iconPosition}`, { disabled }]"
    @click="handleClick"
    v-bind="attrsWithoutClass"
  >
    <span :class="['radio', { on: isSelected }]"></span>
    <span class="label">
      <img v-if="display !== 'text'" :src="item.icon" :alt="item[labelKey]" />
      <template v-if="display !== 'icon'">{{ item[labelKey] }}</template>
    </span>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue'

type Item = Record<string, unknown> & { icon?: string }

const props = withDefaults(
  defineProps<{
    item: Item
    selectList: Item[]
    disabled?: boolean
    selectKey?: string
    labelKey?: string
    display?: 'icon-text' | 'text' | 'icon'
    iconPosition?: 'top' | 'bottom' | 'left' | 'right'
  }>(),
  {
    disabled: false,
    selectKey: 'id',
    labelKey: 'label',
    display: 'icon-text',
    iconPosition: 'top',
  },
)

const emit = defineEmits<{
  (e: 'click', item: Item): void
}>()

const attrs = useAttrs()
// 부모가 넘긴 class는 루트의 'radio-box' 베이스 클래스와 병합되도록 :class에서만 받고, v-bind에서는 제외
const attrsWithoutClass = computed(() => {
  const { class: _class, ...rest } = attrs
  return rest
})

const isSelected = computed(() =>
  props.selectList.some(i => i[props.selectKey] === props.item[props.selectKey]),
)

const handleClick = () => {
  if (!props.disabled) emit('click', props.item)
}
</script>
